import {
    SET_ALL_TOUCHED,
    SET_ERRORS,
    SET_IS_SUBMITTING,
    SET_POSSIBLE_CARD_TYPE,
    SET_TOUCHED,
    SET_VALUE
} from '../actions/zepzPayin/action-types';

export const zepzFormReducer = (state, action) => {
    switch (action.type) {
        case SET_VALUE: {
            const {name, value} = action.payload;

            if (state.values[name] !== value) {
                const values = {
                    ...state.values,
                    [name]: value
                };
                return {
                    ...state,
                    values
                };
            }

            return state;
        }

        case SET_TOUCHED: {
            const touched = {
                ...state.touched,
                [action.payload.name]: true
            };

            return {
                ...state,
                touched,
                areAllTouched: Object.values(touched).every(v => v)
            };
        }

        case SET_ERRORS: {
            const errors = {...action.payload};
            return {
                ...state,
                errors,
                isValid: state.areAllTouched && Object.values(errors).every(v => !v)
            };
        }

        case SET_IS_SUBMITTING: {
            return {
                ...state,
                isSubmitting: action.payload
            };
        }

        case SET_ALL_TOUCHED: {
            const touched = Object.keys(state.touched).reduce((acc, key) => ({...acc, [key]: true}), {});

            return {
                ...state,
                touched,
                areAllTouched: true
            };
        }

        case SET_POSSIBLE_CARD_TYPE: {
            return {
                ...state,
                possibleCardType: action.payload
            };
        }

        default:
            return state;
    }
};
